import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::index
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:31
* @route '/admin/advertisers/at-risk'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/advertisers/at-risk',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::index
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:31
* @route '/admin/advertisers/at-risk'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::index
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:31
* @route '/admin/advertisers/at-risk'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::index
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:31
* @route '/admin/advertisers/at-risk'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::index
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:31
* @route '/admin/advertisers/at-risk'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::index
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:31
* @route '/admin/advertisers/at-risk'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::index
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:31
* @route '/admin/advertisers/at-risk'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::recompute
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:131
* @route '/admin/advertisers/at-risk/recompute'
*/
export const recompute = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: recompute.url(options),
    method: 'post',
})

recompute.definition = {
    methods: ["post"],
    url: '/admin/advertisers/at-risk/recompute',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::recompute
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:131
* @route '/admin/advertisers/at-risk/recompute'
*/
recompute.url = (options?: RouteQueryOptions) => {
    return recompute.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::recompute
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:131
* @route '/admin/advertisers/at-risk/recompute'
*/
recompute.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: recompute.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::recompute
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:131
* @route '/admin/advertisers/at-risk/recompute'
*/
const recomputeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: recompute.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::recompute
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:131
* @route '/admin/advertisers/at-risk/recompute'
*/
recomputeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: recompute.url(options),
    method: 'post',
})

recompute.form = recomputeForm

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::settings
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:196
* @route '/admin/advertisers/at-risk/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: settings.url(options),
    method: 'put',
})

settings.definition = {
    methods: ["put"],
    url: '/admin/advertisers/at-risk/settings',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::settings
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:196
* @route '/admin/advertisers/at-risk/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::settings
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:196
* @route '/admin/advertisers/at-risk/settings'
*/
settings.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: settings.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::settings
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:196
* @route '/admin/advertisers/at-risk/settings'
*/
const settingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::settings
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:196
* @route '/admin/advertisers/at-risk/settings'
*/
settingsForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

settings.form = settingsForm

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::contact
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:141
* @route '/admin/advertisers/{workspace}/at-risk/contact'
*/
export const contact = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contact.url(args, options),
    method: 'post',
})

contact.definition = {
    methods: ["post"],
    url: '/admin/advertisers/{workspace}/at-risk/contact',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::contact
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:141
* @route '/admin/advertisers/{workspace}/at-risk/contact'
*/
contact.url = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { workspace: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { workspace: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            workspace: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        workspace: typeof args.workspace === 'object'
        ? args.workspace.id
        : args.workspace,
    }

    return contact.definition.url
            .replace('{workspace}', parsedArgs.workspace.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::contact
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:141
* @route '/admin/advertisers/{workspace}/at-risk/contact'
*/
contact.post = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: contact.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::contact
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:141
* @route '/admin/advertisers/{workspace}/at-risk/contact'
*/
const contactForm = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: contact.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::contact
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:141
* @route '/admin/advertisers/{workspace}/at-risk/contact'
*/
contactForm.post = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: contact.url(args, options),
    method: 'post',
})

contact.form = contactForm

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::snooze
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:169
* @route '/admin/advertisers/{workspace}/at-risk/snooze'
*/
export const snooze = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: snooze.url(args, options),
    method: 'post',
})

snooze.definition = {
    methods: ["post"],
    url: '/admin/advertisers/{workspace}/at-risk/snooze',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::snooze
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:169
* @route '/admin/advertisers/{workspace}/at-risk/snooze'
*/
snooze.url = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { workspace: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { workspace: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            workspace: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        workspace: typeof args.workspace === 'object'
        ? args.workspace.id
        : args.workspace,
    }

    return snooze.definition.url
            .replace('{workspace}', parsedArgs.workspace.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::snooze
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:169
* @route '/admin/advertisers/{workspace}/at-risk/snooze'
*/
snooze.post = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: snooze.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::snooze
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:169
* @route '/admin/advertisers/{workspace}/at-risk/snooze'
*/
const snoozeForm = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: snooze.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\AdvertiserRiskController::snooze
* @see app/Http/Controllers/Admin/AdvertiserRiskController.php:169
* @route '/admin/advertisers/{workspace}/at-risk/snooze'
*/
snoozeForm.post = (args: { workspace: string | number | { id: string | number } } | [workspace: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: snooze.url(args, options),
    method: 'post',
})

snooze.form = snoozeForm

const atRisk = {
    index: Object.assign(index, index),
    recompute: Object.assign(recompute, recompute),
    settings: Object.assign(settings, settings),
    contact: Object.assign(contact, contact),
    snooze: Object.assign(snooze, snooze),
}

export default atRisk